<template>
  <div class="publish-container">
    <el-card class="publish-card shadow-sm" :body-style="{ padding: '15px' }">
      <div class="input-wrapper">
        <el-input
            v-model="textarea"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            placeholder="有什么新鲜事想分享给大家?"
            class="custom-textarea"
        />
      </div>

      <div class="publish-toolbar">
        <div class="tool-left">
          <el-button type="text" icon="el-icon-picture-outline" class="tool-btn" @click="onImage">
            图片
          </el-button>
          <el-button type="text" icon="el-icon-data-analysis" class="tool-btn" @click="createVote">
            投票
          </el-button>
        </div>
        <div class="tool-right">
          <el-button
              type="primary"
              round
              :disabled="!textarea.trim() && !vote"
              class="send-btn"
              @click="onSubmit"
          >
            发布
          </el-button>
        </div>
      </div>

      <transition name="el-zoom-in-top">
        <div v-if="vote" class="vote-preview-box">
          <div class="vote-preview-header">
            <span class="vote-tag"><i class="el-icon-tickets"></i> 投票预设</span>
            <el-button type="text" icon="el-icon-close" class="close-vote" @click="vote = null"></el-button>
          </div>
          <h4 class="vote-title">{{ vote.title }}</h4>
          <div class="vote-options-list">
            <div
                v-for="(opt, idx) in vote.options"
                :key="idx"
                class="vote-option-item"
                :class="{ 'is-selected': checkedRadio === opt.value }"
                @click="checkedRadio = opt.value; singleCheckChange(opt)"
            >
              <el-radio v-model="checkedRadio" :label="opt.value">{{ opt.name }}</el-radio>
            </div>
          </div>
          <div class="vote-footer">
            <span class="vote-info">截止日期: {{ formatDate(vote.endTime) }}</span>
            <el-button type="primary" size="mini" plain @click="submit">测试提交</el-button>
          </div>
        </div>
      </transition>
    </el-card>

    <el-dialog
        title="新建投票"
        :visible.sync="showVoteDialog"
        width="480px"
        custom-class="vote-dialog"
        :close-on-click-modal="false"
        append-to-body
        center
    >
      <el-form ref="voteForm" :model="voteForm" :rules="voteFormRules" label-position="top">
        <el-form-item label="投票主题" prop="title">
          <el-input v-model="voteForm.title" placeholder="请输入投票名称" maxlength="30" show-word-limit />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="截止日期" prop="endTime">
              <el-date-picker
                  v-model="voteForm.endTime"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望人数" prop="expectNum">
              <el-input-number v-model="voteForm.expectNum" :min="2" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="投票选项 (至少2项)">
          <div v-for="(item, index) in voteForm.options" :key="index" class="option-edit-item">
            <el-input v-model="item.name" placeholder="输入选项内容">
              <el-button slot="append" icon="el-icon-delete" @click="delVoteOption(index)" />
            </el-input>
          </div>
          <el-button
              type="dashed"
              icon="el-icon-plus"
              class="add-option-btn"
              block
              @click="addVoteOption"
          >
            添加选项
          </el-button>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showVoteDialog = false">取 消</el-button>
        <el-button type="primary" @click="addVote">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TextCard',
  data() {
    return {
      textarea: '',
      showVoteDialog: false,
      vote: null,
      checkedRadio: '',
      selectedOption: null,
      voteForm: {
        title: '',
        endTime: null,
        expectNum: 10,
        options: [{ name: '' }, { name: '' }] // 默认给两项
      },
      voteFormRules: {
        title: [{ required: true, message: '请输入投票标题', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择截止时间', trigger: 'change' }]
      }
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString()
    },
    onSubmit() {
      this.$message.success('发布成功')
      this.textarea = ''
      this.vote = null
    },
    onImage() {
      this.$message.info('图片上传功能维护中')
    },
    createVote() {
      this.showVoteDialog = true
    },
    addVoteOption() {
      this.voteForm.options.push({ name: '' })
    },
    delVoteOption(index) {
      if (this.voteForm.options.length <= 2) {
        this.$message.warning('至少需要两个选项')
        return
      }
      this.voteForm.options.splice(index, 1)
    },
    addVote() {
      this.$refs.voteForm.validate(valid => {
        if (valid) {
          const validOptions = this.voteForm.options.filter(o => o.name.trim())
          if (validOptions.length < 2) {
            this.$message.error('请至少填写两个有效选项')
            return
          }
          // 映射 value 以供预览时使用
          this.vote = {
            ...this.voteForm,
            options: validOptions.map((o, index) => ({ ...o, value: index + 1 }))
          }
          this.showVoteDialog = false
          // 重置表单
          this.voteForm = { title: '', endTime: null, expectNum: 10, options: [{ name: '' }, { name: '' }] }
        }
      })
    },
    singleCheckChange(val) {
      this.selectedOption = val
    },
    submit() {
      if (!this.selectedOption) return this.$message.warning('请选择一个选项')
      this.$confirm(`确认选择 [${this.selectedOption.name}]?`, '提示').then(() => {
        this.$message.success('投票成功')
        this.vote = null
      })
    }
  }
}
</script>

<style scoped>
.publish-container {
  max-width: 700px;
  margin: 0 auto;
}

.shadow-sm {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05) !important;
  border: 1px solid #ebeef5;
  border-radius: 12px;
}

/* 输入框优化 */
.custom-textarea /deep/ .el-textarea__inner {
  border: none;
  resize: none;
  font-size: 15px;
  padding: 10px 5px;
  background: transparent;
  transition: all 0.3s;
}

.custom-textarea /deep/ .el-input__count {
  background: transparent;
  bottom: -5px;
}

/* 工具栏 */
.publish-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f2f6fc;
}

.tool-btn {
  color: #606266;
  font-size: 14px;
  margin-right: 15px;
}
.tool-btn:hover {
  color: #409eff;
}
.tool-btn i {
  font-size: 18px;
  vertical-align: middle;
  margin-right: 4px;
}

.send-btn {
  padding: 10px 25px;
  font-weight: bold;
}

/* 投票预览样式 */
.vote-preview-box {
  margin-top: 15px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
  border: 1px dashed #dcdfe6;
}

.vote-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.vote-tag {
  font-size: 12px;
  color: #909399;
  background: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.vote-title {
  margin: 0 0 12px 0;
  color: #303133;
  font-size: 16px;
}

.vote-option-item {
  background: #fff;
  border: 1px solid #dcdfe6;
  padding: 10px 15px;
  margin-bottom: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.vote-option-item:hover {
  border-color: #409eff;
  background: #f0f7ff;
}

.vote-option-item.is-selected {
  border-color: #409eff;
  background: #ecf5ff;
}

.vote-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  font-size: 12px;
  color: #909399;
}

/* 对话框表单优化 */
.option-edit-item {
  margin-bottom: 10px;
}

.add-option-btn {
  width: 100%;
  border-style: dashed;
  margin-top: 5px;
}

.vote-dialog /deep/ .el-dialog__body {
  padding: 10px 25px;
}

.vote-dialog /deep/ .el-dialog__header {
  border-bottom: 1px solid #f2f6fc;
}
</style>
